export default function DataTablePagination(){
  return {
    restrict: "E",
    scope:{
      "source":"="
    },
    template: require("./DataTablePagination.html"),
    link: function(scope, element, attr){
      scope.currentPage = 1;
      scope.limit = +attr.limit || scope.source.limit;
      scope.$watch("source.activeOffset", function(){
        scope.currentPage = 1 + Math.floor(scope.source.activeOffset/scope.limit);
      });
      scope.pageChanged = function(){
        scope.source.offset = (scope.currentPage-1) * scope.limit;
        scope.source.load();
      }
    }    
  }
}


// WEBPACK FOOTER //
// ./src/DataTable/DataTablePagination.js